<mat-error *ngIf=" control?.invalid && control?.touched" class="error" [style]="customStyle">
    <!-- rquired  -->
    <ng-container *ngIf="control?.errors?.required; else elseErrors">{{'errors.required' |
        translate}}</ng-container>

    <ng-template #elseErrors>
        <!-- length check for string-->
        <ng-container *ngIf="control?.errors?.minLength">
            {{'errors.minlength' | translate : {actualLength : control?.errors.minLength.actualLength, minLength
            :control?.errors.minLength.minLength}
            }}
        </ng-container>

        <ng-container *ngIf="control?.errors?.maxLength">
            {{'errors.maxlength' | translate : {actualLength: control?.errors.maxLength.actualLength, maxLength:
            control?.errors.maxLength.maxLength} }}
        </ng-container>

        <!-- length check for number-->
        <ng-container *ngIf="control?.errors?.min">
            {{'errors.min' | translate}}{{control?.errors.min.minLength}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.max">
            {{'errors.max' | translate}}{{control?.errors.max.maxLength}}
        </ng-container>

        <!-- length check for date-->
        <ng-container *ngIf="control?.errors?.minDate">
            {{'errors.minDate' | translate : {minDate : control?.errors.minDate.requiredDate} }}
        </ng-container>

        <ng-container *ngIf="control?.errors?.maxDate">
            {{'errors.maxDate' | translate : {maxDate : control?.errors.maxDate.requiredDate} }}
        </ng-container>

        <ng-container *ngIf="control?.errors?.precision">
            {{'errors.precision' | translate : {requiredPrecision: control?.errors.precision.requiredPrecision,
            actualPercision:
            control?.errors.precision.actualPrecision} }}
        </ng-container>

        <!-- pattern  -->
        <ng-container *ngIf="control?.errors?.pattern">
            <ng-container [ngSwitch]="type">
                <ng-container *ngSwitchCase="'email'">
                    {{'errors.email' | translate}} <span>example&#64;gmail.com</span>
                </ng-container>
                <ng-container *ngSwitchCase="'phone'">
                    {{ 'errors.invalid_phone' | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                    {{'errors.number' | translate}}
                </ng-container>
                <ng-container *ngSwitchCase="'artext'">
                    {{'errors.arPattern' | translate}}
                </ng-container>
                <ng-container *ngSwitchCase="'lattext'">
                    {{'errors.latPattern' | translate}}
                </ng-container>
                <ng-container *ngSwitchDefault>
                    {{'errors.pattern' | translate}}
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="control?.errors?.userNotFound">
            {{'errors.userNotFound' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.userIdExistAsCustomer">
            {{'errors.userIdExistAsCustomer' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.userIdExistAsEmployee">
            {{'errors.userIdExistAsEmployee' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.codeExist">
            {{'errors.codeExist' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.userExist">
            {{'errors.userExist' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.emailExist">
            {{'errors.emailExist' | translate}}
        </ng-container>

        <ng-container *ngIf="control?.errors?.duplicate">
            <span>{{'errors.duplicate' | translate}}</span>
        </ng-container>

        <ng-container *ngIf="control?.errors?.invalidDate">
            <span>{{'errors.invalidDate' | translate}}</span>
        </ng-container>

        <ng-container *ngIf="control?.errors?.notFound">
            <span>{{'errors.notFound' | translate}}</span>
        </ng-container>
    </ng-template>
</mat-error>